module.exports = __webpack_public_path__ + "static/media/formsPhone.a9af3b57.webp";